/* =========================================================================
   ARVENT Orbit: JavaScript do tema (sem bibliotecas, ~10 KB)
   - Carrinho lateral com a Cart AJAX API da Shopify
   - Palco do produto (frente/costas/detalhes) e estrela em órbita
   - Barra de compra fixa no telemóvel
   ========================================================================= */
(() => {
  const A = window.ARVENT || {}, R = A.routes || {};
  const $ = (s, c = document) => c.querySelector(s), $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const html = document.documentElement;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- Dinheiro no formato da loja ---------- */
  function money(cents, f = A.moneyFormat || '€{{amount}}') {
    cents = Math.round(+cents || 0);
    const num = (n, p, t = ',', d = '.') => { const [i, x] = (n / 100).toFixed(p).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (x ? d + x : ''); };
    const m = f.match(/\{\{\s*(\w+)\s*\}\}/); if (!m) return num(cents, 2);
    const v = { amount: num(cents, 2), amount_no_decimals: num(cents, 0), amount_with_comma_separator: num(cents, 2, '.', ','), amount_no_decimals_with_comma_separator: num(cents, 0, '.', ','), amount_with_apostrophe_separator: num(cents, 2, "'", '.'), amount_with_space_separator: num(cents, 2, ' ', ',') }[m[1]] || num(cents, 2);
    return f.replace(m[0], v);
  }
  const rate = () => (window.Shopify && Shopify.currency && +Shopify.currency.rate) || 1;
  const sized = (u, w) => u ? u + (u.includes('?') ? '&' : '?') + 'width=' + w : '';

  let tT; const toast = m => { const t = $('#toast'); if (!t) return; t.textContent = m; t.classList.add('on'); clearTimeout(tT); tT = setTimeout(() => t.classList.remove('on'), 2800); };

  /* ---------- Cart API ---------- */
  const json = { 'Content-Type': 'application/json', Accept: 'application/json' };
  const api = {
    get: () => fetch(R.cart + '.js', { headers: { Accept: 'application/json' } }).then(r => r.json()),
    add: async items => { const r = await fetch(R.cartAdd + '.js', { method: 'POST', headers: json, body: JSON.stringify({ items }) }); const d = await r.json(); if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart.'); return d; },
    change: async (id, quantity) => { const r = await fetch(R.cartChange + '.js', { method: 'POST', headers: json, body: JSON.stringify({ id, quantity }) }); const d = await r.json(); if (!r.ok) throw new Error(d.description || d.message || 'Could not update the cart.'); return d; }
  };
  let CART = null;
  const refresh = () => api.get().then(c => { CART = c; render(); }).catch(() => {});

  function render() {
    if (!CART) return;
    const c = CART, n = c.item_count, thr = Math.round((A.freeShippingCents || 0) * rate());
    $$('[data-count]').forEach(e => e.textContent = n);
    const ship = $('#ship');
    if (ship) {
      ship.hidden = !thr;
      const left = thr - c.total_price;
      $('#shipMsg').textContent = n === 0 ? `Free shipping on orders over ${money(thr)}.` : left <= 0 ? "You've unlocked free shipping." : `Add ${money(left)} more for free shipping.`;
      $('#shipBar').style.width = thr ? Math.min(100, c.total_price / thr * 100) + '%' : '0';
    }
    const list = $('#lines'); const a = document.activeElement; let keep = '';
    if (a && list && list.contains(a)) for (const k of ['data-inc', 'data-dec', 'data-rm']) if (a.hasAttribute(k)) keep = `[${k}="${a.getAttribute(k)}"]`;
    if (list) list.innerHTML = c.items.map(i => `
      <div class="line">
        ${i.image ? `<img src="${esc(sized(i.image, 200))}" alt="" width="72" height="88" loading="lazy">` : '<span></span>'}
        <div>
          <p class="line__name">${esc(i.product_title)}</p>
          <p class="line__meta">${i.variant_title && i.variant_title !== 'Default Title' ? 'Size ' + esc(i.variant_title) : ''}</p>
          <div class="qty" role="group" aria-label="Quantity of ${esc(i.product_title)}">
            <button type="button" data-dec="${esc(i.key)}" aria-label="Decrease quantity">−</button><output>${i.quantity}</output><button type="button" data-inc="${esc(i.key)}" aria-label="Increase quantity">+</button>
          </div>
        </div>
        <div class="line__end">
          <b>${i.original_line_price > i.final_line_price ? `<s style="color:var(--mute);font-weight:400;margin-right:6px">${money(i.original_line_price)}</s>` : ''}${money(i.final_line_price)}</b>
          <button class="linkbtn" type="button" data-rm="${esc(i.key)}">Remove</button>
        </div>
      </div>`).join('');
    if (keep) { const el = $(keep, list); (el || $('#cart [data-close]')).focus(); }
    $('#empty').hidden = n > 0;
    const co = $('#checkout'); co.disabled = n === 0; co.style.opacity = n ? 1 : .4;
    const disc = c.original_total_price - c.total_price;
    $('#sum').innerHTML = n ? `<dt>Subtotal</dt><dd>${money(c.original_total_price)}</dd>${disc > 0 ? `<dt>Discounts</dt><dd>−${money(disc)}</dd>` : ''}<dt>Shipping</dt><dd>${thr && c.total_price >= thr ? 'Free' : 'At checkout'}</dd><dt class="tot">Total</dt><dd class="tot">${money(c.total_price)}</dd>` : '';
  }

  /* ---------- Gaveta do carrinho ---------- */
  const drawer = $('#cart'); let back = null;
  const openCart = () => { if (!drawer || drawer.open) return; back = document.activeElement; drawer.showModal(); html.style.overflow = 'hidden'; void drawer.offsetWidth; drawer.classList.add('open'); };
  const closeCart = () => { if (!drawer || !drawer.open) return; drawer.classList.remove('open'); setTimeout(() => { drawer.close(); html.style.overflow = ''; back && back.focus && back.focus(); }, reduce ? 0 : 380); };
  if (drawer) {
    drawer.addEventListener('cancel', e => { e.preventDefault(); closeCart(); });
    drawer.addEventListener('click', e => { if (e.target === drawer && e.clientX < drawer.getBoundingClientRect().left) closeCart(); });
  }

  document.addEventListener('click', e => {
    const t = e.target;
    if (t.closest('#openCart')) { e.preventDefault(); openCart(); return; }
    if (t.closest('#cart [data-close]')) { closeCart(); return; }
    if (t.closest('#checkout')) { location.href = R.root.replace(/\/?$/, '/') + 'checkout'; return; }
    const q = t.closest('[data-inc],[data-dec],[data-rm]');
    if (q && CART) {
      const key = q.dataset.inc || q.dataset.dec || q.dataset.rm, line = CART.items.find(i => i.key === key); if (!line) return;
      const qty = q.dataset.inc ? line.quantity + 1 : q.dataset.dec ? line.quantity - 1 : 0;
      api.change(key, qty).then(c => { CART = c; render(); if (q.dataset.inc) { const l = c.items.find(i => i.key === key); if (l && l.quantity === line.quantity) toast('No more stock in this size.'); } }).catch(err => toast(err.message));
      return;
    }
    const g = t.closest('[data-guide]');
    if (g) { e.preventDefault(); const d = $('#guide'); if (d) d.showModal(); return; }
    if (t.closest('[data-close-guide]')) { $('#guide').close(); return; }
  });
  const guide = $('#guide'); if (guide) guide.addEventListener('click', e => { if (e.target === guide) guide.close(); });

  /* ---------- Formulário do produto ---------- */
  const form = $('#product-form');
  const chosen = () => { const r = form && $('input[name="id"]:checked', form); if (r) return r; const d = form && $('[data-default-variant]', form); return d || null; };
  function askSize() {
    const f = $('#sizes'), note = $('#note'); if (note) note.textContent = 'Choose your size first.';
    if (f) { f.classList.remove('shake'); void f.offsetWidth; f.classList.add('shake'); }
    const first = form && $('input[name="id"]:not(:disabled)', form); if (first) first.focus({ preventScroll: true });
    const buy = $('#buy'); if (buy) buy.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
  }
  async function addFlow(btn) {
    const v = chosen(); if (!v) return askSize();
    const b = btn || $('#add'); if (b) b.disabled = true;
    try {
      await api.add([{ id: +v.value, quantity: 1 }]);
      await refresh();
      $('#note') && ($('#note').textContent = '');
      if (b) { const o = b.textContent; b.classList.add('done'); b.textContent = 'Added'; setTimeout(() => { b.classList.remove('done'); b.textContent = o; }, 1500); }
      const c = $('#openCart'); c && (c.classList.remove('bump'), void c.offsetWidth, c.classList.add('bump'));
      setTimeout(openCart, reduce ? 0 : 250);
    } catch (err) { toast(err.message); $('#note') && ($('#note').textContent = err.message); }
    finally { if (b) b.disabled = false; }
  }
  if (form) {
    form.addEventListener('submit', e => { e.preventDefault(); addFlow($('#add')); });
    form.addEventListener('change', e => {
      const r = e.target; if (r.name !== 'id') return;
      const note = $('#note'); if (note) note.textContent = r.dataset.low ? `Only ${r.dataset.low} left in ${r.dataset.size}.` : '';
      if (r.dataset.price) $$('[data-price]').forEach(p => p.textContent = r.dataset.price);
      const bb = $('#barBtn'); if (bb) bb.textContent = 'Add to cart';
    });
  }
  const barBtn = $('#barBtn'); if (barBtn) barBtn.addEventListener('click', () => addFlow(barBtn));

  /* ---------- Palco: frente / costas / detalhes ---------- */
  const stage = $('#stage');
  if (stage) {
    const imgs = $$('.stage__img', stage);
    const set = i => {
      stage.dataset.view = i; stage.dataset.detail = i >= 2;
      imgs.forEach(im => im.classList.toggle('is-on', +im.dataset.index === i));
      $$('.thumb').forEach(t => t.setAttribute('aria-pressed', +t.dataset.view === i));
      const h = $('#hint'); if (h) h.hidden = i >= 2;
    };
    $$('.thumb').forEach(t => t.addEventListener('click', () => set(+t.dataset.view)));
    if (imgs.length > 1) {
      const flip = () => set(+stage.dataset.view === 0 ? 1 : 0);
      stage.addEventListener('click', flip);
      stage.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); flip(); } });
    }
    /* Estrela em órbita: passa atrás e à frente do hoodie */
    const sb = $('#starBack'), sf = $('#starFront');
    if (sb && sf) {
      const cx = 500, cy = 560, rx = 440, ry = 120; let t = -Math.PI * .2, last = 0, raf = null;
      const place = () => { const s = Math.sin(t), x = cx + rx * Math.cos(t), y = cy + ry * s, k = .75 + .4 * (s + 1) / 2, tr = `translate(${x.toFixed(1)} ${y.toFixed(1)}) scale(${k.toFixed(3)})`; sb.setAttribute('transform', tr); sf.setAttribute('transform', tr); sf.style.opacity = s > 0 ? 1 : 0; sb.style.opacity = s > 0 ? 0 : 1; };
      place();
      if (!reduce) {
        const loop = now => { const dt = last ? Math.min(50, now - last) : 16; last = now; t += dt * .00045; place(); raf = requestAnimationFrame(loop); };
        new IntersectionObserver(([e]) => { if (e.isIntersecting && !raf) { last = 0; raf = requestAnimationFrame(loop); } else if (!e.isIntersecting && raf) { cancelAnimationFrame(raf); raf = null; } }).observe(stage);
      }
    }
  }

  /* ---------- Cabeçalho e barra fixa ---------- */
  const head = $('#head');
  if (head && !head.classList.contains('solid')) { const upd = () => head.classList.toggle('solid', scrollY > 40); addEventListener('scroll', upd, { passive: true }); upd(); }
  /* Barra de compra fixa (telemóvel): aparece sempre que o botão principal não está à vista */
  const bar = $('#bar'), add = $('#add');
  if (bar && add) new IntersectionObserver(([e]) => { const on = !e.isIntersecting; bar.classList.toggle('on', on); on ? bar.removeAttribute('inert') : bar.setAttribute('inert', ''); }, { rootMargin: '0px 0px -40px 0px' }).observe(add);

  /* Botões "Choose your size" fora da caixa de compra: levam ao tamanho */
  document.addEventListener('click', e => {
    const g = e.target.closest('[data-go-size]'); if (!g || !$('#buy')) return;
    e.preventDefault();
    $('#buy').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    const first = form && $('input[name="id"]:not(:disabled)', form); if (first) setTimeout(() => first.focus({ preventScroll: true }), reduce ? 0 : 600);
  });

  /* ---------- Faixas em movimento (barra de anúncios + faixa grande) ----------
     Animadas em JS para funcionarem igual em todos os telemóveis. Com "menos movimento" ligado no sistema, andam a metade da velocidade.
     Pausam com o rato por cima (só em computador) e quando estão fora do ecrã. */
  const marquees = [];
  $$('[data-marquee]').forEach(el => {
    const tr = $('.mq__track', el), g = tr && $('.mq__g', tr); if (!g) return;
    const m = { el, tr, w: 0, x: 0, dir: el.classList.contains('marquee--rev') ? 1 : -1, speed: (+el.dataset.speed || 50) * (reduce ? .5 : 1), vis: true, hover: false };
    const fit = () => {
      m.w = g.getBoundingClientRect().width; if (!m.w) return;
      const need = Math.ceil(el.clientWidth / m.w) + 2;
      while (tr.children.length < need) tr.appendChild(g.cloneNode(true));
    };
    fit();
    if ('ResizeObserver' in window) new ResizeObserver(fit).observe(el);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    if (matchMedia('(hover: hover)').matches) { el.addEventListener('mouseenter', () => m.hover = true); el.addEventListener('mouseleave', () => m.hover = false); }
    if ('IntersectionObserver' in window) new IntersectionObserver(([e]) => { m.vis = e.isIntersecting; }).observe(el);
    marquees.push(m);
  });
  if (marquees.length) {
    html.classList.add('mq-js');
    let last = 0;
    const tick = now => {
      const dt = last ? Math.min(64, now - last) / 1000 : 0; last = now;
      for (const m of marquees) {
        if (!m.w || !m.vis || m.hover || document.hidden) continue;
        m.x += m.dir * m.speed * dt;
        if (m.x <= -m.w) m.x += m.w; else if (m.x > 0) m.x -= m.w;
        m.tr.style.transform = `translate3d(${m.x.toFixed(2)}px,0,0)`;
      }
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  /* ---------- Data de entrega estimada (dias úteis) ---------- */
  $$('[data-eta]').forEach(el => {
    const add = (d, n) => { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; };
    const now = new Date(), a = add(now, +el.dataset.min || 2), b = add(now, +el.dataset.max || 5);
    const day = d => d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric' }), mon = d => d.toLocaleDateString('en-GB', { month: 'short' });
    const txt = a.getMonth() === b.getMonth() ? `${day(a)} – ${day(b)} ${mon(b)}` : `${day(a)} ${mon(a)} – ${day(b)} ${mon(b)}`;
    const t = $('[data-eta-text]', el); if (t) t.innerHTML = `Order today, get it <b>${esc(txt)}</b>`;
  });

  /* ---------- Contagem decrescente do drop (data em hora de Lisboa) ---------- */
  $$('[data-countdown]').forEach(el => {
    const m = (el.dataset.date || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{1,2}):(\d{2})/); if (!m) return;
    const guess = Date.UTC(+m[1], m[2] - 1, +m[3], +m[4], +m[5]);
    const off = (() => { try { const p = Object.fromEntries(new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Lisbon', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }).formatToParts(new Date(guess)).map(x => [x.type, x.value])); return Date.UTC(+p.year, p.month - 1, +p.day, +p.hour, +p.minute) - guess; } catch (e) { return 0; } })();
    const target = guess - off, pad = n => String(n).padStart(2, '0');
    const out = { d: $('[data-d]', el), h: $('[data-h]', el), m: $('[data-m]', el), s: $('[data-s]', el) };
    const before = $('.cd__before', el), after = $('.cd__after', el);
    const step = () => {
      let left = Math.max(0, Math.floor((target - Date.now()) / 1000));
      if (!left) { if (el.dataset.after === 'hide') el.hidden = true; else { before.hidden = true; after.hidden = false; } return false; }
      out.d.textContent = pad(Math.floor(left / 86400)); left %= 86400; out.h.textContent = pad(Math.floor(left / 3600)); left %= 3600; out.m.textContent = pad(Math.floor(left / 60)); out.s.textContent = pad(left % 60);
      return true;
    };
    if (step()) { const iv = setInterval(() => { if (!step()) clearInterval(iv); }, 1000); }
  });

  /* Editor de temas: recarregar o carrinho quando uma secção muda */
  document.addEventListener('shopify:section:load', refresh);
  refresh();
})();
